module.exports = __webpack_public_path__ + "img/tree1.23455499.png";